import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as gatewayService from '@frolight/services/api/gatewayService';

const useConnectedUnitsData = (gatewayId) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const getConnectedUnitsAbortController = new AbortController();
    const getConnectedUnits = async () => {
      if (mounted) setLoading(true);

      try {
        const connectedUnits = await authenticatedAPIServiceCall(
          gatewayService.getUnitsConnectedToGateway,
          {
            abortController: getConnectedUnitsAbortController,
            opts: {
              gatewayId: gatewayId
            }
          }
        );
        
        if (connectedUnits && connectedUnits.data) {
          // Sort on active status (active first), then name (alphabetical)
          const sortedUnits = [...connectedUnits.data].sort((a, b) => {
            if (a.isActive && !b.isActive) {
              return -1;
            } else if (!a.isActive && b.isActive) {
              return 1;
            } else {
              return (a.name || a.deviceId).localeCompare(b.name || b.deviceId);
            }
          });
          if (mounted) setData(sortedUnits);
        } else {
          if (mounted) setError(new Error(`Error getting connected units for gateway "${gatewayId}"`));
        }
      } catch (err) {
        console.error(err);
        if (err.name !== 'AbortError') {
          if (mounted) setError(err);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (gatewayId) {
      getConnectedUnits();
    }

    return () => {
      mounted = false;
      getConnectedUnitsAbortController.abort();
    }

  }, [ gatewayId ]);

  return { loading, error, data };
};

export default useConnectedUnitsData;